import { ParallaxDirection, ParallaxType } from '../../core/modules/Parallax/ParallaxController';
import { Theme, ThemeName, Weather } from './theme';

export const parkThemeNight: Theme = {
  id: ThemeName.ParkNight,
  texture: 'theme-park-night',
  isNight: true,
  weather: Weather.Dry,
  parallaxLayers: [
    // {
    //   type: ParallaxType.Tile,
    //   x: 960,
    //   y: 166.5,
    //   width: 1920,
    //   height: 333,
    //   texture: 'theme-park-night',
    //   frame: 'bg-sky.png',
    //   depth: 1,
    //   scrollX: 0,
    //   scrollY: 0,
    //   speedX: 0,
    //   speedY: 0,
    //   naturalDriftX: 0,
    //   naturalDriftY: 0
    // },
    {
      type: ParallaxType.Sprite,
      direction: ParallaxDirection.Horizontal,
      x: 0,
      y: 166.5,
      texture: 'theme-park-night',
      images: [
        {
          frame: 'bg-sky.png',
          gapBefore: -2
        },
        {
          frame: 'bg-sky.png',
          gapBefore: -2
        },
        {
          frame: 'bg-sky.png',
          gapBefore: -2
        }
      ],
      depth: 1,
      scrollX: 0,
      scrollY: 0,
      speedX: 0,
      speedY: 0,
      naturalDriftX: 0,
      naturalDriftY: 0
    },
    // {
    //   type: ParallaxType.Tile,
    //   x: 960,
    //   y: 213.5,
    //   width: 1920,
    //   height: 427,
    //   texture: 'theme-park-night',
    //   frame: 'tile-parkcity.png',
    //   depth: 2,
    //   scrollX: 0,
    //   scrollY: 0,
    //   speedX: 0.1,
    //   speedY: 0,
    //   naturalDriftX: 0,
    //   naturalDriftY: 0
    // },
    {
      type: ParallaxType.Sprite,
      direction: ParallaxDirection.Horizontal,
      x: 0,
      y: 213.5,
      texture: 'theme-park-night',
      images: [
        {
          frame: 'tile-parkcity.png',
          gapBefore: -2
        },
        {
          frame: 'tile-parkcity.png',
          gapBefore: -2
        },
        {
          frame: 'tile-parkcity.png',
          gapBefore: -2
        }
      ],
      depth: 2,
      scrollX: 0,
      scrollY: 0,
      speedX: 0.1,
      speedY: 0,
      naturalDriftX: 0,
      naturalDriftY: 0
    },
    // {
    //   type: ParallaxType.Tile,
    //   x: 960,
    //   y: 218,
    //   width: 1920,
    //   height: 436,
    //   texture: 'theme-park-night',
    //   frame: 'tile-park-fg.png',
    //   depth: 3,
    //   scrollX: 0,
    //   scrollY: 0,
    //   speedX: 0.25,
    //   speedY: 0,
    //   naturalDriftX: 0,
    //   naturalDriftY: 0
    // },
    {
      type: ParallaxType.Sprite,
      direction: ParallaxDirection.Horizontal,
      x: 0,
      y: 218,
      texture: 'theme-park-night',
      images: [
        {
          frame: 'tile-park-fg.png',
          gapBefore: -2
        },
        {
          frame: 'tile-park-fg.png',
          gapBefore: -2
        },
        {
          frame: 'tile-park-fg.png',
          gapBefore: -2
        }
      ],
      depth: 3,
      scrollX: 0,
      scrollY: 0,
      speedX: 0.25,
      speedY: 0,
      naturalDriftX: 0,
      naturalDriftY: 0
    },
    // {
    //   type: ParallaxType.Tile,
    //   x: 960,
    //   y: 533,
    //   width: 1920,
    //   height: 493,
    //   texture: 'theme-park-night',
    //   frame: 'tile-road-park-night.png',
    //   depth: 4,
    //   scrollX: 0,
    //   scrollY: 0,
    //   speedX: 1,
    //   speedY: 0,
    //   naturalDriftX: 0,
    //   naturalDriftY: 0
    // },
    {
      type: ParallaxType.Sprite,
      direction: ParallaxDirection.Horizontal,
      x: 0,
      y: 533,
      texture: 'theme-park-night',
      images: [
        {
          frame: 'tile-road-park-night.png',
          gapBefore: -2
        },
        {
          frame: 'tile-road-park-night.png',
          gapBefore: -2
        },
        {
          frame: 'tile-road-park-night.png',
          gapBefore: -2
        }
      ],
      depth: 4,
      scrollX: 0,
      scrollY: 0,
      speedX: 1,
      speedY: 0,
      naturalDriftX: 0,
      naturalDriftY: 0
    },
    // {
    //   type: ParallaxType.Tile,
    //   x: 960,
    //   y: 280,
    //   width: 1920,
    //   height: 82,
    //   texture: 'theme-park-night',
    //   frame: 'tile-bg-people-park-night.png',
    //   depth: 5,
    //   scrollX: 0,
    //   scrollY: 0,
    //   speedX: 1,
    //   speedY: 0,
    //   naturalDriftX: 0,
    //   naturalDriftY: 0
    // },
    {
      type: ParallaxType.Sprite,
      direction: ParallaxDirection.Horizontal,
      x: 0,
      y: 280,
      texture: 'theme-park-night',
      images: [
        {
          frame: 'tile-bg-people-park-night.png',
          gapBefore: -2
        },
        {
          frame: 'tile-bg-people-park-night.png',
          gapBefore: -2
        },
        {
          frame: 'tile-bg-people-park-night.png',
          gapBefore: -2
        }
      ],
      depth: 5,
      scrollX: 0,
      scrollY: 0,
      speedX: 1,
      speedY: 0,
      naturalDriftX: 0,
      naturalDriftY: 0
    }
  ],
  roadDetails: {
    laneCount: 4,
    lanes: {
      0: { laneY: 86 },
      1: { laneY: 90 },
      2: { laneY: 95 },
      3: { laneY: 100 }
    },
    laneHeight: 100,
    laneScale: 0.05,
    laneVehicleScale: 0.025,
    startPointX: 0,
    startPointY: -52.5,
    vehicleOffset: 10,
    obstacleOffset: -20,
    pavementY: 378,
    pavementHeight: 77
  }
};
